import { useSelector } from 'react-redux';
import { MatchRuleEntity } from 'src/store/matchRuleApi';
import { selectSortedMatchRules } from 'src/store/matchRuleSlice';
import { Panel } from 'src/ui/Panel';
import { Button } from 'src/ui/Button';
import { Icon } from 'src/ui/Icon';

export interface OutlineProps {
  onAddNew: () => void;
  setSelectedMatchRule: (matchRule: MatchRuleEntity, scroll: boolean) => void;
}

const Outline = ({ onAddNew, setSelectedMatchRule }: OutlineProps) => {
  const orderedMatchRules = useSelector(selectSortedMatchRules);
  return (
    <Panel
      className="grow"
      title="Outline"
      icon="git-branch"
      headerRight={
        <Button
          variant="primary"
          size="sm"
          iconOnly
          onClick={onAddNew}
          title="Add rule"
        >
          <Icon name="plus" size={16} />
        </Button>
      }
    >
      <div className="grow scroll-y" style={{ margin: '0 -6px' }}>
        {orderedMatchRules.map((matchRule) => (
          <div
            key={matchRule.id}
            role="button"
            tabIndex={0}
            className="list-row"
            onClick={() => setSelectedMatchRule(matchRule, true)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ')
                setSelectedMatchRule(matchRule, true);
            }}
          >
            <div className="grow" style={{ minWidth: 0 }}>
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 'var(--fs-sm)',
                  color: matchRule.disabled
                    ? 'var(--text-muted)'
                    : 'var(--text)',
                  textDecoration: matchRule.disabled ? 'line-through' : 'none',
                }}
              >
                {matchRule.sequence}. {matchRule.name}
              </div>
              <div
                className="text-muted"
                style={{ fontSize: 'var(--fs-xs)', marginTop: 1 }}
              >
                weight {matchRule.weightMale}% / {matchRule.weightFemale}%
              </div>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
};

export default Outline;
